import { defaultTo, isNull } from 'lodash-es';
import type { CurrentOrganisation } from '../organizations/user-id-token';
import type { AccessTokenPayload, IdTokenPayload } from '../tokens';

// key is resourceName
export type UserResourceAccess = Record<string, { roles: string[] }>;

export type User = {
  anrede: string | null;
  vorname: string;
  nachname: string;
  displayName: string;
  activeOrganization: CurrentOrganisation;
  selectedPartner?: string;
  email: string;
  image: string | null;
  resourceAccess: UserResourceAccess;
};

export const toUser = (
  idToken: IdTokenPayload | null,
  accessToken: AccessTokenPayload | null,
): User | null => {
  if (isNull(idToken)) {
    return null;
  }

  return {
    anrede: null,
    vorname: idToken.given_name,
    nachname: idToken.family_name,
    displayName: idToken.name,
    activeOrganization: idToken.activeOrganization,
    selectedPartner: idToken.selectedPartner,
    email: idToken.email,
    image: null,
    resourceAccess: defaultTo(accessToken?.resource_access, {}),
  };
};
